import { useState } from "react";
import { FileField } from "../../../../ui/index.ts";

export type OnboardingDocumentUploadFieldProps = {
  id: string;
  label: string;
  required?: boolean;
  file: File | null;
  disabled?: boolean;
  error?: string;
  validateFile: (file: File) => string | undefined;
  onChange: (file: File | null) => void;
};

/** Region-neutral onboarding document input with consistent file validation/reset behavior. */
export function OnboardingDocumentUploadField({
  id,
  label,
  required = false,
  file,
  disabled = false,
  error: externalError,
  validateFile,
  onChange,
}: OnboardingDocumentUploadFieldProps) {
  const [error, setError] = useState<string>();
  const [inputKey, setInputKey] = useState(0);

  return (
    <FileField
      key={`${id}-${inputKey}`}
      id={id}
      label={label}
      required={required}
      accept="image/*,.pdf,application/pdf"
      stagedFile={file}
      disabled={disabled}
      error={externalError ?? error}
      onChange={(nextFile) => {
        setError(undefined);
        if (!nextFile) {
          onChange(null);
          return;
        }
        const validationError = validateFile(nextFile);
        if (validationError) {
          setError(validationError);
          onChange(null);
          setInputKey((value) => value + 1);
          return;
        }
        onChange(nextFile);
      }}
    />
  );
}

